export type Compound = 'THC' | 'CBD' | 'TAC' | 'THCA' | 'TERPS';

export const VALID_DISPLAY_CANNABINOIDS: readonly Compound[] = [
  'THC',
  'CBD',
  'TAC',
  'THCA',
  'TERPS',
] as const;
